/* eslint-disable react-hooks/exhaustive-deps */
import React, {forwardRef, useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import moment from 'moment';
import {Link, useParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import classNames from 'classnames';
import DatePicker from 'react-datepicker';
import {ru} from 'date-fns/locale';
import {useStore} from '../../../../store/store';
import {CreateAppModal, useThemeMode} from '../../../../_metronic/partials';
import PageWrapper from '../../../modules/PageWrapper';
import Navigation from '../../../modules/NavigationBloggers';
import Warning from '../../../modules/Warning';
import Preloader from '../../../modules/Preloader';
import Calendar from '../../../modules/calendar/Calendar';
import Card from '../../../shared/Card';
import PaginationBe from '../../../shared/PaginationBe';
import {SelectorWithSearch} from '../../../shared/Selectors';
import {formatNumber, formatNumber2} from '../../../functions/formatNumber';
import css from '../../traffic/influence/bloggers/blogger/Blogger.module.scss';
import pickerCss from '../../../../styles/CustomPicker.module.scss';
import activityStyles from '../../../../styles/Activity.module.scss';
import imagePlug from '../../../../_metronic/assets/media/user.png';

const momentTZ = require('moment-timezone');

const safeNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const addThousands = (value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

const normalizeNumericString = (value) => {
  if (value === null || value === undefined) return '0';

  let normalizedValue = String(value).trim();
  normalizedValue = normalizedValue.replace(/\s+/g, '').replace(/[^0-9.,-]/g, '');

  if (normalizedValue.includes(',') && normalizedValue.includes('.')) {
    normalizedValue = normalizedValue.replace(/,/g, '');
  } else {
    normalizedValue = normalizedValue.replace(',', '.');
  }

  if (normalizedValue === '' || normalizedValue === '-') return '0';

  return normalizedValue;
};

const formatMoneyTruncate = (value) => {
  let normalizedValue = normalizeNumericString(value);
  const isNegative = normalizedValue.startsWith('-');

  if (isNegative) normalizedValue = normalizedValue.slice(1);

  let [integerPart, fractionPart = ''] = normalizedValue.split('.');
  integerPart = integerPart.replace(/^0+(?=\d)/, '');
  fractionPart = fractionPart.slice(0, 2).padEnd(2, '0');

  return `${isNegative ? '-' : ''}${addThousands(integerPart === '' ? '0' : integerPart)}.${fractionPart}$`;
};

const formatMoneyNoDecimals = (value) => {
  let normalizedValue = normalizeNumericString(value);
  const isNegative = normalizedValue.startsWith('-');

  if (isNegative) normalizedValue = normalizedValue.slice(1);

  let integerPart = normalizedValue.split('.')[0];
  integerPart = integerPart.replace(/^0+(?=\d)/, '');

  return `${isNegative ? '-' : ''}${addThousands(integerPart === '' ? '0' : integerPart)}$`;
};

const getImage = (image) => {
  return image ? `${process.env.REACT_APP_API_HOST}/${image}` : imagePlug;
};

const getWorkspaceAvatar = (workspace) => {
  return getImage(workspace?.avatar || workspace?.logo || workspace?.image);
};

const getManagerName = (manager) => {
  const user = manager?.manager || manager;
  const name = [user?.first_name, user?.last_name].filter(Boolean).join(' ');

  return name || `#${user?.id || '-'}`;
};

const getLtcStatus = (ltcCategories, ltc) => {
  const ltcValue = safeNumber(ltc);
  const category = ltcCategories.find((item) => {
    return ltcValue >= safeNumber(item.ltc_min) && ltcValue < safeNumber(item.ltc_max);
  });

  return category?.indicator || 'secondary';
};

const getRdStatus = (rdCategories, averageCheck) => {
  const averageCheckValue = safeNumber(averageCheck);
  const category = rdCategories.find((item) => {
    return averageCheckValue >= safeNumber(item.rd_min) && averageCheckValue <= safeNumber(item.rd_max);
  });

  return category?.indicator || 'secondary';
};

const workspaceTabs = [
  {link: 'ltc', title: 'LTC Менеджера'},
  {link: 'rd', title: 'RD Менеджера'},
  {link: 'activity', title: 'Активность'},
  {link: 'logs', title: 'Логи'},
];

const workspaceTabContentStyle = {
  minHeight: '620px',
};

const HeaderMetric = ({icon, title, value, color = 'primary'}) => {
  return (
    <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2'>
      <div className='d-flex align-items-center'>
        <i className={`ki-duotone ${icon} fs-3 text-${color} me-2`}>
          <span className='path1'></span>
          <span className='path2'></span>
          <span className='path3'></span>
          <span className='path4'></span>
        </i>
        <div className='fs-4 fw-bold'>{value}</div>
      </div>
      <div className='fw-semibold fs-6 text-gray-400'>{title}</div>
    </div>
  );
};

const HeaderManagersMetric = ({title, total, trainees}) => {
  const verified = Math.max(safeNumber(total) - safeNumber(trainees), 0);

  return (
    <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2'>
      <div className='d-flex align-items-center gap-4'>
        <div className='d-flex align-items-center'>
          <i className='ki-duotone ki-verify fs-3 text-primary me-1'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
          <div className='fs-4 fw-bold'>{formatNumber(verified)}</div>
        </div>
        <div className='d-flex align-items-center'>
          <i className='ki-duotone ki-verify fs-3 text-gray-500 me-1'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
          <div className='fs-4 fw-bold'>{formatNumber(trainees)}</div>
        </div>
      </div>
      <div className='fw-semibold fs-6 text-gray-400'>{title}</div>
    </div>
  );
};

const WorkspaceHeader = ({workspace, stats, page, setPage, ltcStatus, rdStatus}) => {
  return (
    <div className='card mb-8' id='workspaceHeader'>
      <div className='card-body p-5 pb-0'>
        <div className={css.header}>
          <div
            className={css.avatar}
            style={{
              backgroundImage: `url(${getWorkspaceAvatar(workspace)})`,
            }}
          />
          <section className={css.bloggerData}>
            <div className={css.nameContainer}>
              <span className='text-gray-800 fs-2 fw-bold'>{workspace?.name || 'Workspace'}</span>
            </div>
            <div className={css.otherData}>
              <div className='fw-semibold fs-5 text-gray-400'>#{workspace?.id || '-'}</div>
              <OverlayTrigger
                delay={{hide: 250, show: 250}}
                placement='top'
                overlay={(props) => (
                  <Tooltip className='fs-8' {...props}>
                    LTC
                  </Tooltip>
                )}
              >
                <span className={`badge badge-light-${ltcStatus} me-auto`}>
                  {formatNumber2(stats?.ltc)}%
                </span>
              </OverlayTrigger>
              <OverlayTrigger
                delay={{hide: 250, show: 250}}
                placement='top'
                overlay={(props) => (
                  <Tooltip className='fs-8' {...props}>
                    Средний чек
                  </Tooltip>
                )}
              >
                <span className={`badge badge-light-${rdStatus} me-auto`}>
                  {formatMoneyTruncate(stats?.average_deposit)}
                </span>
              </OverlayTrigger>
            </div>
          </section>
          <section className={css.metrics}>
            <HeaderManagersMetric
              title='Менеджера'
              total={stats?.users_count}
              trainees={stats?.trainees_count}
            />
            <HeaderManagersMetric
              title='Активные'
              total={stats?.active_users_count}
              trainees={stats?.active_trainees_count}
            />
            <HeaderMetric
              icon='ki-message-text-2'
              title='Чаты'
              value={formatNumber(stats?.chats_count)}
            />
            <HeaderMetric
              icon='ki-user-tick'
              title='Квалификации'
              value={formatNumber(stats?.qualifications_count)}
              color='success'
            />
            <HeaderMetric
              icon='ki-dollar'
              title='Сумма депозитов'
              value={formatMoneyNoDecimals(stats?.deposits_amount)}
              color='primary'
            />
          </section>
        </div>

        <div className='separator'></div>
        <Navigation page={page} setPage={setPage} links={workspaceTabs} />
      </div>
    </div>
  );
};

const VerificationInline = ({verified, unverified}) => {
  return (
    <span className='d-inline-flex align-items-center gap-2 ms-5'>
      <span className='d-inline-flex align-items-center text-primary fw-bold'>
        <i className='ki-duotone ki-verify fs-5 text-primary me-1'>
          <span className='path1'></span>
          <span className='path2'></span>
        </i>
        {formatNumber(verified)}
      </span>
      <span className='d-inline-flex align-items-center text-gray-500 fw-bold'>
        <i className='ki-duotone ki-verify fs-5 text-gray-500 me-1'>
          <span className='path1'></span>
          <span className='path2'></span>
        </i>
        {formatNumber(unverified)}
      </span>
    </span>
  );
};

const SummaryCard = ({title, total, verified, unverified, icon}) => {
  return (
    <div className='col-xl-6'>
      <div className='border border-gray-300 border-dashed rounded p-5 h-100'>
        <div className='d-flex align-items-center'>
          <i className={`ki-duotone ${icon} fs-2x text-primary me-3`}>
            <span className='path1'></span>
            <span className='path2'></span>
            <span className='path3'></span>
          </i>
          <div>
            <div className='fw-bold fs-3 text-gray-900 d-flex align-items-center'>
              {formatNumber(total)}
              <VerificationInline verified={verified} unverified={unverified} />
            </div>
            <div className='fw-semibold fs-6 text-gray-500'>{title}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ManagersSummary = ({type, total, managersCount}) => {
  const traineesCount = safeNumber(total?.trainees_count);
  const activeCount = safeNumber(total?.active_users_count);
  const activeTraineesCount = safeNumber(total?.active_trainees_count);

  return (
    <Card className='card mb-8'>
      <div className='card-body'>
        <div className='row g-5'>
          <SummaryCard
            title='Всего'
            total={managersCount}
            verified={Math.max(safeNumber(managersCount) - traineesCount, 0)}
            unverified={traineesCount}
            icon='ki-profile-circle'
          />
          <SummaryCard
            title='Активные'
            total={activeCount}
            verified={Math.max(activeCount - activeTraineesCount, 0)}
            unverified={activeTraineesCount}
            icon='ki-timer'
          />
        </div>
      </div>
    </Card>
  );
};

const ManagerCell = ({manager}) => {
  const user = manager?.manager || manager;
  const isVerified = !!(user?.is_verified || user?.is_verify);
  const isBan = !!user?.is_ban;

  return (
    <div className='d-flex align-items-center'>
      <div className='symbol symbol-45px me-3'>
        <img src={getImage(user?.avatar)} alt='' />
      </div>
      <div className='d-flex flex-column'>
        <span className='d-flex align-items-center text-gray-800 fw-bold'>
          {getManagerName(manager)}
          {isVerified && (
            <OverlayTrigger
              delay={{hide: 450, show: 300}}
              placement='right'
              overlay={(props) => (
                <Tooltip className='fs-8' {...props}>
                  {user?.verify_date ? `Верифицирован ${user.verify_date}` : 'Верифицирован'}
                </Tooltip>
              )}
            >
              <span className='d-flex align-items-center ms-2'>
                <i className='ki-duotone ki-verify fs-1 text-primary'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                </i>
              </span>
            </OverlayTrigger>
          )}
          {isBan && (
            <OverlayTrigger
              delay={{hide: 450, show: 300}}
              placement='right'
              overlay={(props) => (
                <Tooltip className='fs-8' {...props}>
                  {user?.ban_date ? `Заблокирован ${user.ban_date}` : 'Заблокирован'}
                </Tooltip>
              )}
            >
              <span className='d-flex align-items-center ms-2'>
                <i className='ki-duotone ki-lock-3 fs-1 text-danger'>
                  <span className='path1'></span>
                  <span className='path2'></span>
                  <span className='path3'></span>
                </i>
              </span>
            </OverlayTrigger>
          )}
        </span>
        <span className='text-gray-400 fw-semibold fs-7'>#{user?.id || '-'}</span>
      </div>
    </div>
  );
};

const ChangeTraffic = observer(({is_traffic = false, manager, id, onChange = () => {}}) => {
  const store = useStore();
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [traffic, setTraffic] = useState(false);

  useEffect(() => {
    if (typeof is_traffic === 'undefined') return setTraffic(false);
    setTraffic(is_traffic);
  }, [is_traffic]);

  const save = async (newTraffic) => {
    setShowCreateAppModal(false);
    const result = await store.requestPost('Sales/Manager/updateTraffic', {
      data: {is_traffic: newTraffic, manager_id: id},
      preloader: false,
    });

    if (!!result) {
      setTraffic(newTraffic);
      onChange(newTraffic);
      return toast.success('Успешно обновлено!', {});
    }

    toast.error('Произошла ошибка в обновлении!', {
      theme: 'colored',
    });
  };

  return (
    <>
      <div className='form-check form-check-solid form-check-custom form-switch'>
        <input
          className='form-check-input w-45px h-30px'
          disabled={store.roles.includes(13) || store.roles.includes(32) ? true : false}
          style={{cursor: 'pointer'}}
          type='checkbox'
          name='is_traffic'
          checked={traffic}
          onChange={() => {
            setShowCreateAppModal(true);
          }}
        />
        <label className='form-check-label' htmlFor='is_traffic'></label>
      </div>
      <CreateAppModal
        customWidth='mw-400px'
        padding='pb-lg-10 pt-lg-10 px-lg-10'
        show={showCreateAppModal}
        handleClose={() => setShowCreateAppModal(false)}
        showHeader={false}
        isMessage={true}
      >
        <Warning
          text={
            <span>
              Вы уверены что хотите {traffic ? 'отключить' : 'включить'} трафик для{' '}
              <span className='text-primary'>{manager}</span>
            </span>
          }
          icon={
            <span className='symbol-label'>
              <i className='bi bi-question-circle fs-5x text-warning'></i>
            </span>
          }
          buttons={[
            {
              action: () => {
                setShowCreateAppModal(false);
              },
              title: <i className='bi bi-x p-0 fs-1'></i>,
              class: 'btn-light',
            },
            {
              action: async () => {
                save(!traffic);
              },
              title: <i className='bi bi-check p-0 fs-1'></i>,
              class: 'btn-light-primary',
            },
          ]}
        />
      </CreateAppModal>
    </>
  );
});

const ManagersTable = ({type, data, setData, ltcCategories, rdCategories}) => {
  const rows = data?.managers || [];
  const columnCount = type === 'ltc' ? 7 : 7;

  const setTrafficForManager = (managerId, isTraffic) => {
    setData((prev) => ({
      ...prev,
      managers: (prev?.managers || []).map((row) => {
        if (row?.manager?.id !== managerId) return row;

        return {...row, manager: {...row.manager, is_traffic: isTraffic}};
      }),
    }));
  };

  return (
    <Card className='card'>
      <div className='card-body pt-0'>
        <div className='table-responsive'>
          <table className='table table-row-bordered table-row-dashed gy-4 align-middle fw-bold'>
            <thead className='fs-7 text-gray-400 text-uppercase'>
              <tr>
                <th className='min-w-250px'>Менеджер</th>
                <th className='min-w-100px text-center'>Трафик</th>
                {type === 'ltc' && <th className='min-w-120px text-center'>Чаты</th>}
                <th className='min-w-120px text-center'>Квалификации</th>
                {type !== 'ltc' && <th className='min-w-100px text-center'>Депозиты</th>}
                <th className='min-w-150px text-center'>Сумма депозитов</th>
                {type === 'ltc' && <th className='min-w-80px text-center'>LTC</th>}
                <th className='min-w-120px text-end'>Средний чек</th>
              </tr>
            </thead>
            <tbody className='fs-6'>
              {rows.map((row) => (
                <tr key={row?.manager?.id || row?.id}>
                  <td>
                    <ManagerCell manager={row} />
                  </td>
                  <td className='text-center'>
                    <div className='d-flex justify-content-center'>
                      <ChangeTraffic
                        is_traffic={row?.manager?.is_traffic}
                        manager={getManagerName(row)}
                        id={row?.manager?.id}
                        onChange={(value) => setTrafficForManager(row?.manager?.id, value)}
                      />
                    </div>
                  </td>
                  {type === 'ltc' && (
                    <td className='text-center'>
                      <span className='text-gray-900 fw-bold d-block mb-1 fs-6'>
                        {formatNumber(row?.chats_count)}
                      </span>
                    </td>
                  )}
                  <td className='text-center'>
                    <span className='text-gray-900 fw-bold d-block mb-1 fs-6'>
                      {formatNumber(row?.qualifications_count)}
                    </span>
                  </td>
                  {type !== 'ltc' && (
                    <td className='text-center'>
                      <span className='text-gray-500 fw-semibold d-block mb-1 fs-6'>
                        {formatNumber(row?.deposits_count)}
                      </span>
                    </td>
                  )}
                  <td className='text-center'>
                    <span
                      className={`${
                        type === 'rd' ? 'text-gray-900 fw-bold' : 'text-gray-500 fw-semibold'
                      } d-block mb-1 fs-6`}
                    >
                      {formatMoneyNoDecimals(row?.deposits_amount)}
                    </span>
                  </td>
                  {type === 'ltc' && (
                    <td className='text-center'>
                      <span
                        className={`badge badge-light-${getLtcStatus(ltcCategories, row?.ltc)} fw-bold px-4 py-3`}
                      >
                        {formatNumber2(row?.ltc)}%
                      </span>
                    </td>
                  )}
                  <td className='text-end'>
                    <span
                      className={`badge badge-light-${
                        type === 'ltc' ? 'primary' : getRdStatus(rdCategories, row?.average_deposit)
                      } fw-bold px-4 py-3`}
                    >
                      {formatMoneyTruncate(row?.average_deposit)}
                    </span>
                  </td>
                </tr>
              ))}
              {!rows.length && (
                <tr>
                  <td className='text-center text-gray-400 py-10' colSpan={columnCount}>
                    Нет данных
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Card>
  );
};

const ManagersStatistics = observer(({id, type, timeConfig}) => {
  const store = useStore();
  const [data, setData] = useState({total: {}, managers: []});
  const [ltcCategories, setLtcCategories] = useState([]);
  const [rdCategories, setRdCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!timeConfig?.time_config) return;
    getData();
  }, [id, type, timeConfig]);

  const getData = async () => {
    setLoading(true);
    try {
      const [response, ltcList, rdList] = await Promise.all([
        store.requestGet(`user/sales/workspaces/${id}/${type}/statistics`, {
          params: timeConfig,
          preloader: false,
        }),
        type === 'ltc'
          ? store.requestGet('Finance/Category/getLtcList', {preloader: false})
          : Promise.resolve([]),
        store.requestGet('Finance/Category/getRdList', {preloader: false}),
      ]);

      setData(response || {total: {}, managers: []});
      setLtcCategories(ltcList || []);
      setRdCategories(rdList || []);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <div className='text-gray-400 fw-semibold mb-4'>Загрузка...</div>}
      <ManagersSummary type={type} total={data?.total || {}} managersCount={data?.managers?.length || 0} />
      <ManagersTable
        type={type}
        data={data}
        setData={setData}
        ltcCategories={ltcCategories}
        rdCategories={rdCategories}
      />
    </>
  );
});

const ActivityFilter = ({value, setValue}) => {
  const buttons = [
    {value: 'all', title: 'Все'},
    {value: 'ltc', title: 'LTC'},
    {value: 'rd', title: 'RD'},
  ];

  return (
    <div className='d-flex align-items-center gap-2'>
      {buttons.map((button) => (
        <button
          key={button.value}
          type='button'
          className={`btn btn-sm ${value === button.value ? 'btn-primary' : 'btn-light-primary'}`}
          onClick={() => setValue(button.value)}
        >
          {button.title}
        </button>
      ))}
    </div>
  );
};

const getActivityManagerType = (manager, currentType) => {
  if (currentType === 'ltc' || currentType === 'rd') return currentType;

  const rawType = String(
    manager?.type || manager?.manager_type || manager?.department || manager?.sales_type || ''
  ).toLowerCase();

  if (rawType.includes('rd')) return 'rd';
  if (rawType.includes('ltc')) return 'ltc';

  return 'ltc';
};

const Activity = observer(({id}) => {
  const store = useStore();
  const theme = useThemeMode();
  const [prel, setPrel] = useState(false);
  const [mode, setMode] = useState('');
  const [type, setType] = useState('all');
  const [activity, setActivity] = useState([]);
  const [activityContainerWidth, setActivityContainerWidth] = useState(0);
  const [date, setDate] = useState('');
  const [startTimeForRequest, setStartTimeForRequest] = useState('');

  useEffect(() => {
    initTime();
  }, []);

  useEffect(() => {
    if (!startTimeForRequest) return;
    const container = document.getElementById('activity-line-0');
    if (container) setActivityContainerWidth(container.offsetWidth);
    getActivity(moment(startTimeForRequest).format('YYYY-MM-DD'), type);
  }, [startTimeForRequest, type]);

  useEffect(() => {
    if (theme.mode === 'system') {
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        setMode('dark');
      } else {
        setMode('light');
      }
    } else {
      setMode(theme.mode);
    }
  }, [theme]);

  const getActivity = async (date, type) => {
    setPrel(true);
    try {
      const params = type === 'all' ? {date} : {date, type};
      const response = await store.requestGet(`user/sales/workspaces/${id}/managers/activity`, {
        params,
        preloader: false,
      });
      setActivity(response || []);
    } finally {
      setPrel(false);
    }
  };

  const CustomInput = forwardRef(({value, onClick}, ref) => (
    <div
      className='form-control form-control-solid mb-lg-0 w-140px h-40px d-flex align-items-center justify-content-center fw-semibold'
      onClick={onClick}
      ref={ref}
      value={value}
    >
      {value}
    </div>
  ));

  const getKyivOffset = () => {
    return (moment.tz('Europe/Kiev').utcOffset() / 60) * 60 * 60 * 1000;
  };

  const getTimezoneOffset = (date) => {
    const timezoneOffsetInMinutes = date.getTimezoneOffset();
    const hoursOffset = (Math.abs(timezoneOffsetInMinutes) / 60) * 60 * 60 * 1000;

    return {timezoneOffsetInMinutes, hoursOffset};
  };

  const initTime = () => {
    const kievOffset = getKyivOffset();
    const {timezoneOffsetInMinutes, hoursOffset} = getTimezoneOffset(new Date());

    if (timezoneOffsetInMinutes > 0) {
      const diff = hoursOffset + kievOffset;
      const currentTime = new Date(new Date().getTime() + diff).setHours(0, 0, 0);
      setDate(currentTime);
      setStartTimeForRequest(currentTime - hoursOffset);
    } else if (timezoneOffsetInMinutes < 0) {
      if (kievOffset > hoursOffset) {
        const diff = kievOffset - hoursOffset;
        const currentTime = new Date(new Date().getTime() + diff).setHours(0, 0, 0);
        setDate(currentTime);
        setStartTimeForRequest(currentTime + hoursOffset);
      } else if (kievOffset < hoursOffset) {
        const diff = hoursOffset - kievOffset;
        const currentTime = new Date(new Date().getTime() - diff).setHours(0, 0, 0);
        setDate(currentTime);
        setStartTimeForRequest(currentTime + hoursOffset);
      } else {
        const currentTime = new Date().setHours(0, 0, 0);
        setDate(currentTime);
        setStartTimeForRequest(currentTime + hoursOffset);
      }
    } else {
      const diff = hoursOffset + kievOffset;
      const currentTime = new Date(new Date().getTime() + diff).setHours(0, 0, 0);
      setDate(currentTime);
      setStartTimeForRequest(currentTime);
    }
  };

  const changeDate = async (start, e) => {
    function getMillisecondsForMidnightInKievFromGMT(h, m, s, date) {
      const kievTime = momentTZ(date).tz('Europe/Kiev');
      const utcTime = kievTime.clone().utc();
      utcTime.hours(h);
      utcTime.minutes(m);
      utcTime.seconds(s);
      return utcTime.valueOf();
    }

    setDate(start);

    const yearStart = start.getFullYear();
    const monthStart = start.getMonth();
    const dayStart = Number(e.target.innerText);
    const selectDateStart = new Date();
    selectDateStart.setUTCFullYear(yearStart);
    selectDateStart.setUTCMonth(monthStart);
    selectDateStart.setUTCDate(dayStart);
    selectDateStart.setUTCHours(0, 0, 0);

    const midnightInMillisStart = getMillisecondsForMidnightInKievFromGMT(
      0,
      0,
      0,
      selectDateStart
    );

    setStartTimeForRequest(midnightInMillisStart);
  };

  const calculateTotalDuration = (segments = []) => {
    let totalDurationMs = 0;

    segments.forEach((segment) => {
      const segmentDurationMs = segment.time_end * 1000 - segment.time_start * 1000;
      totalDurationMs += segmentDurationMs;
    });

    const totalDuration = moment.duration(totalDurationMs);
    const hours = Math.floor(totalDuration.asHours());
    const minutes = totalDuration.minutes();

    return (
      <span
        className={`badge badge-light-${hours < 6 ? 'danger' : 'success'} fw-bold px-4 py-3`}
      >{`${hours} ч ${minutes} мин`}</span>
    );
  };

  const calculateIntervalWidth = (
    startDayMs,
    endDayMs,
    intervalStartMs,
    intervalEndMs,
    blockWidth
  ) => {
    const dayDurationMs = endDayMs - startDayMs;
    const intervalDurationMs = intervalEndMs - intervalStartMs;

    return {
      intervalPercentage: (intervalDurationMs / dayDurationMs) * 100,
      intervalWidth: (intervalDurationMs / dayDurationMs) * blockWidth,
    };
  };

  const formatDuration = (durationMs) => {
    const duration = moment.duration(durationMs);
    const minutes = Math.floor(duration.asMinutes());
    return `${minutes} мин`;
  };

  const getTimeSegments = (timeStart, timeEnd, arrSegments = []) => {
    const containerWidth = activityContainerWidth;
    const dayDurationMs = timeEnd - timeStart;
    const arrDivs = [];
    let previousEnd = timeStart;

    arrSegments.forEach((segment) => {
      const segmentStart = segment.time_start * 1000;
      const segmentEnd = segment.time_end * 1000;

      if (segmentStart > previousEnd) {
        const gapDurationMs = segmentStart - previousEnd;
        const gapTime = `${moment(previousEnd).format('HH:mm')}-${moment(segmentStart).format(
          'HH:mm'
        )}`;

        arrDivs.push({
          type: 'gap',
          width: (gapDurationMs / dayDurationMs) * containerWidth,
          timePeriod: `${gapTime} (${formatDuration(gapDurationMs)})`,
        });
      }

      const segmentWidth = calculateIntervalWidth(
        timeStart,
        timeEnd,
        segmentStart,
        segmentEnd,
        containerWidth
      );
      const segmentTime = `${moment(segmentStart).format('HH:mm')}-${moment(segmentEnd).format(
        'HH:mm'
      )}`;

      arrDivs.push({
        type: 'segment',
        width: segmentWidth.intervalWidth,
        timePeriod: `${segmentTime} (${formatDuration(segmentEnd - segmentStart)})`,
      });

      previousEnd = segmentEnd;
    });

    if (previousEnd < timeEnd) {
      const gapDurationMs = timeEnd - previousEnd;
      const gapTime = `${moment(previousEnd).format('HH:mm')}-${moment(timeEnd).format('HH:mm')}`;

      arrDivs.push({
        type: 'gap',
        width: (gapDurationMs / dayDurationMs) * containerWidth,
        timePeriod: `${gapTime} (${formatDuration(gapDurationMs)})`,
      });
    }

    if (!arrDivs.length) {
      return (
        <div className={activityStyles.segmentContainer}>
          <div className={activityStyles.gap} style={{width: `${containerWidth}px`}}></div>
          <span className={classNames(activityStyles.gapTime, 'fs-8 fw-600')}>
            <span className={activityStyles.marker} />
            00:00-23:59 (1440 мин)
          </span>
        </div>
      );
    }

    return arrDivs.map((item, index) => (
      <React.Fragment key={index}>
        {item.type === 'gap' && (
          <div className={activityStyles.segmentContainer}>
            <div className={activityStyles.gap} style={{width: `${item.width}px`}}></div>
            <span className={classNames(activityStyles.gapTime, 'fs-8 fw-600')}>
              <span className={activityStyles.marker} />
              {item.timePeriod}
            </span>
          </div>
        )}
        {item.type === 'segment' && (
          <div className={activityStyles.segmentContainer}>
            <div className={activityStyles.segment} style={{width: `${item.width}px`}}></div>
            <span className={classNames(activityStyles.gapTime, 'fs-8 fw-600')}>
              <span className={activityStyles.marker} />
              {item.timePeriod}
            </span>
          </div>
        )}
      </React.Fragment>
    ));
  };

  return (
    <div className='card card-flush'>
      <div className='card-header mt-5'>
        <div className='card-title flex-column'>
          <h3 className='fw-bold mb-1'>Активность</h3>
        </div>
        <div className='d-flex flex-wrap align-items-center gap-3 position-relative mb-5 mb-sm-5 mb-md-0'>
          <ActivityFilter value={type} setValue={setType} />
          <DatePicker
            calendarClassName={classNames(
              pickerCss.container,
              pickerCss[`_${mode}`],
              mode === 'dark' ? pickerCss.dark : pickerCss.light
            )}
            calendarStartDay={1}
            locale={ru}
            dateFormat='dd/MM/yyyy'
            selected={date}
            onChange={changeDate}
            customInput={<CustomInput />}
          />
        </div>
      </div>
      <div className='card-body pt-0'>
        <div className='table-responsive'>
          <table
            id='kt_profile_overview_table'
            className='table table-row-bordered table-row-dashed gy-4 align-middle fw-bold'
          >
            <thead className='fs-7 text-gray-400 text-uppercase'>
              <tr>
                <th className='min-w-200px'>Менеджер</th>
                <th className='min-w-600px max-w-800px text-center' id='activity-line-0'>
                  Активность
                </th>
                <th className='min-w-110px text-center text-nowrap'>Время работы</th>
                <th className='min-w-100px text-center'>Сообщения</th>
              </tr>
            </thead>
            <tbody className='fs-6'>
              {activity.map((item) => {
                return (
                  <tr key={item.id}>
                    <td>
                      <ManagerCell manager={item} />
                    </td>
                    <td>
                      <div
                        className={classNames(activityStyles.activityContainer)}
                        style={
                          mode === 'dark'
                            ? {'--tooltipMode': 'rgb(31, 31, 90)', '--tooltipTextMode': 'white'}
                            : {'--tooltipMode': '#ebebeb', '--tooltipTextMode': 'black'}
                        }
                      >
                        {getTimeSegments(item.time_start * 1000, item.time_end * 1000, item.times)}
                      </div>
                    </td>
                    <td className='text-center'>{calculateTotalDuration(item.times)}</td>
                    <td className='text-center'>{formatNumber(item.count_messages)}</td>
                  </tr>
                );
              })}
              {!activity.length && !prel && (
                <tr>
                  <td className='text-center text-gray-400 py-10' colSpan={4}>
                    Нет данных
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {prel && <Preloader style={{border: '0'}} />}
        </div>
      </div>
    </div>
  );
});

const Logs = observer(({id}) => {
  const store = useStore();
  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [prel, setPrel] = useState(false);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [action, setAction] = useState({label: 'Все', value: 2});
  const [calendarTime, setCalendarTime] = useState({
    time_config: '',
    time_start: '',
    time_end: '',
  });
  const [tc, setTc] = useState({
    time_config: '',
    time_start: '',
    time_end: '',
  });
  const [label, setLabel] = useState('');
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    getLogs();
  }, []);

  const buildParams = (currentPage = 1, currentAction = action, currentTime = tc) => {
    const params = {
      page: currentPage,
      perPage,
      is_traffic: currentAction.value,
      time_config: currentTime.time_config,
      time_start: currentTime.time_start ? Math.floor(currentTime.time_start) : '',
      time_end: currentTime.time_end ? Math.floor(currentTime.time_end) : '',
    };

    if (currentAction.value === 2) delete params.is_traffic;

    return params;
  };

  const getLogs = async (currentPage = 1, currentAction = action, currentTime = tc) => {
    setPrel(true);

    const response = await store.requestGet(`user/sales/workspaces/${id}/managers/activity/logs`, {
      params: buildParams(currentPage, currentAction, currentTime),
      preloader: false,
    });

    setLogs(response?.rows || []);
    setTotal(response?.total || 0);
    setPrel(false);
  };

  const filterActions = async (event) => {
    setAction(event);
    setPage(1);
    await getLogs(1, event);
  };

  const handleCustom = async (obj, forCalendar) => {
    const {time_start, time_end} = obj;

    let start = moment.utc(time_start).format('DD.MM.YYYY');
    let end = time_end ? moment.utc(time_end).format('DD.MM.YYYY') : '';

    setLabel(start !== end ? `${start} - ${end}` : start);
    setCalendarTime({
      time_start: forCalendar.startDate,
      time_end: forCalendar.endDate,
      sendStart: obj.time_start,
      sendEnd: obj.time_end,
    });

    const nextTime = {
      time_config: 'custom',
      time_start: Math.floor(obj.time_start / 1000) || '',
      time_end: Math.floor(obj.time_end / 1000),
    };

    setTc(nextTime);
    setPage(1);
    await getLogs(1, action, nextTime);
  };

  return (
    <div className='card card-flush'>
      <div className='card-header mt-5'>
        <div className='d-flex flex-wrap align-items-center position-relative mb-5 mb-sm-5 mb-md-0'>
          <div className='me-4 mt-2 min-w-20'>
            <SelectorWithSearch
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  height: '42px',
                }),
              }}
              placeholder='Оффер...'
              options={[
                {label: 'Все', value: 2},
                {label: 'Включен', value: 1},
                {label: 'Отключен', value: 0},
              ]}
              actions={(event) => filterActions(event)}
              value={action}
            />
          </div>
          <div
            className='menu-item d-flex align-items-center mt-2'
            onClick={() => {
              setShowCreateAppModal(!showCreateAppModal);
            }}
          >
            <button className='btn btn-light fw-bold text-nowrap text-gray-500 me-1'>
              {label || 'Поиск по дате...'}
            </button>
          </div>
          {showCreateAppModal && (
            <Calendar
              showCreateAppModal={showCreateAppModal}
              setShowCreateAppModal={setShowCreateAppModal}
              handleCustom={handleCustom}
              timeConfig={calendarTime}
            />
          )}
        </div>
      </div>

      <div className='card-body pt-0'>
        <div className='table-responsive'>
          <table
            id='kt_profile_overview_table'
            className='table table-row-bordered table-row-dashed gy-4 align-middle fw-bold'
          >
            <thead className='fs-7 text-gray-400 text-uppercase'>
              <tr>
                <th className='min-w-150px'>Менеджер</th>
                <th className='min-w-200px text-center'>Действие</th>
                <th className='min-w-250px'>Ответственный</th>
                <th className='min-w-90px text-center'>Дата</th>
              </tr>
            </thead>
            <tbody className='fs-6'>
              {logs.map((item) => {
                const managerType = getActivityManagerType(item, '');

                return (
                  <tr key={`${item.id}`}>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='me-5 position-relative'>
                          <div className='symbol symbol-35px symbol-circle'>
                            <img src={getImage(item?.manager_avatar)} alt='' />
                          </div>
                        </div>

                        <div className='d-flex flex-column justify-content-center'>
                          <Link to={`/sales/${managerType}/managers/${item.manager_id}`}>
                            <span className='d-flex align-items-center fs-6 text-gray-800 text-hover-primary cursor-pointer'>
                              {item.manager_fname} {item.manager_lname}
                            </span>
                          </Link>
                          <div className='fw-semibold text-gray-400'>#{item.manager_id}</div>
                        </div>
                      </div>
                    </td>
                    <td className='text-center'>
                      <span
                        className={`badge badge-light-${
                          item.is_traffic ? 'success' : 'danger'
                        } fw-bold px-4 py-3`}
                      >
                        {item.is_traffic ? 'Включен' : 'Отключен'}
                      </span>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='me-5 position-relative'>
                          <div className='symbol symbol-35px symbol-circle'>
                            <img src={getImage(item?.user_avatar)} alt='' />
                          </div>
                        </div>

                        <div className='d-flex flex-column justify-content-center'>
                          <span className='d-flex align-items-center fs-6 text-gray-800'>
                            {item.user_fname} {item.user_lname}
                          </span>
                          <div className='fw-semibold text-gray-400'>#{item.user_id}</div>
                        </div>
                      </div>
                    </td>
                    <td className='fw-semibold text-gray-700 text-center'>
                      {item.created
                        ? momentTZ(item.created * 1000).tz('Europe/Kyiv').format('HH:mm DD/MM/YYYY')
                        : '-'}
                    </td>
                  </tr>
                );
              })}
              {!logs.length && !prel && (
                <tr>
                  <td className='text-center text-gray-400 py-10' colSpan={4}>
                    Нет данных
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {prel && <Preloader style={{border: '0'}} />}
        </div>
        <PaginationBe
          arrLength={total}
          limit={perPage}
          page={page}
          setPage={setPage}
          action={(currentPage) => getLogs(currentPage)}
        />
      </div>
    </div>
  );
});

const Component = observer(({timeConfig, isVerify, setPreloader, id}) => {
  const store = useStore();
  const [page, setPage] = useState('ltc');
  const [workspace, setWorkspace] = useState({});
  const [stats, setStats] = useState({});
  const [ltcCategories, setLtcCategories] = useState([]);
  const [rdCategories, setRdCategories] = useState([]);

  useEffect(() => {
    if (isVerify && timeConfig?.time_config) {
      getData();
    }
  }, [id, timeConfig, isVerify]);

  const getData = async () => {
    try {
      const [workspaceResponse, statsResponse, ltcList, rdList] = await Promise.all([
        store.requestGet(`user/sales/workspaces/${id}`, {preloader: false}),
        store.requestGet(`user/sales/workspaces/${id}/statistics`, {
          params: timeConfig,
          preloader: false,
        }),
        store.requestGet('Finance/Category/getLtcList', {preloader: false}),
        store.requestGet('Finance/Category/getRdList', {preloader: false}),
      ]);

      setWorkspace(workspaceResponse || {});
      setStats(statsResponse || {});
      setLtcCategories(ltcList || []);
      setRdCategories(rdList || []);
    } finally {
      setPreloader(false);
    }
  };

  return (
    <>
      <WorkspaceHeader
        workspace={workspace}
        stats={stats}
        page={page}
        setPage={setPage}
        ltcStatus={getLtcStatus(ltcCategories, stats?.ltc)}
        rdStatus={getRdStatus(rdCategories, stats?.average_deposit)}
      />
      <div style={workspaceTabContentStyle}>
        {page === 'ltc' && <ManagersStatistics id={id} type='ltc' timeConfig={timeConfig} />}
        {page === 'rd' && <ManagersStatistics id={id} type='rd' timeConfig={timeConfig} />}
        {page === 'activity' && <Activity id={id} />}
        {page === 'logs' && <Logs id={id} timeConfig={timeConfig} />}
      </div>
    </>
  );
});

const Workspace = () => {
  const params = useParams();

  const breadcrumbs = {
    br: [
      {title: 'Panely', path: '/dashboard/sales'},
      {isSeparator: true},
      {
        title: `Workspace #${params.id}`,
        path: `/sales/workspaces/${params.id}`,
        isActive: true,
      },
    ],
    title: `Workspace #${params.id}`,
  };

  return (
    <PageWrapper
      breadcrumbs={breadcrumbs.br}
      title={breadcrumbs.title}
      firstTimeConfig='current_week'
    >
      <Component id={params.id} />
    </PageWrapper>
  );
};

export default observer(Workspace);
